export default "__VITE_ASSET__DnewLfkG__"